export default "/images/vendor/flag-icons/flags/1x1/ir.svg?5f436531c4e843c9e7b96fcfbfd74244";